var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "brick-settings-base",
        {
          attrs: {
            title: _vm.resource("JourneyComposer_BrickSettingsAudience_Title"),
            canWrite: _vm.canWrite,
            prompt: {
              title: _vm.resource(
                "JourneyBuilder_AudienceSettings_Delete_Title"
              ),
              body: _vm.resource("JourneyBuilder_AudienceSettings_Delete_Body")
            }
          },
          on: {
            save: _vm.saveSettings,
            delete: function($event) {
              return _vm.$emit("delete")
            },
            hidden: function($event) {
              return _vm.$emit("hide")
            }
          },
          model: {
            value: _vm.newName,
            callback: function($$v) {
              _vm.newName = $$v
            },
            expression: "newName"
          }
        },
        [
          _c("settings-item", {
            attrs: { icon: "fas fa-user-friends" },
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [
                      _c("label", { attrs: { for: _vm.fieldName } }, [
                        _vm._v(_vm._s(_vm.fieldName))
                      ])
                    ]
                  },
                  proxy: true
                },
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-select",
                        {
                          staticClass: "form-control",
                          attrs: {
                            label: "name",
                            options: _vm.audiences,
                            disabled: !_vm.canWrite,
                            clearable: false,
                            searchable: "",
                            filterable: ""
                          },
                          model: {
                            value: _vm.selectedAudience,
                            callback: function($$v) {
                              _vm.selectedAudience = $$v
                            },
                            expression: "selectedAudience"
                          }
                        },
                        [
                          _c("div", {
                            attrs: { slot: "no-options" },
                            slot: "no-options"
                          })
                        ]
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              256620355
            )
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }